module.exports = __webpack_public_path__ + "static/media/Alabastra.9a59ff1e.mp4";